"use client";

import type { ReactNode } from "react";
import {
  type Option,
  SelectField,
  TextAreaField,
} from "@/components/tool-kit/primitives";
import { BUTTON_SMALL } from "@/components/tool-kit/styles";
import type { HeaderMode } from "@/lib/tool-kit/stats-research/matrix";

/*
 * The data box the research-statistics widgets share: a monospace text area for a
 * spreadsheet paste, the header-row choice, and small actions (load the example,
 * clear). Every word comes from the widget's own strings.
 */

export interface PasteAction {
  label: string;
  onClick: () => void;
}

export function PasteBox({
  id,
  label,
  hint,
  placeholder,
  value,
  onChange,
  rows = 8,
  header,
  actions,
}: {
  id: string;
  label: string;
  hint?: ReactNode;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  header?: {
    label: string;
    value: HeaderMode;
    onChange: (value: HeaderMode) => void;
    options: readonly Option<HeaderMode>[];
  };
  actions: readonly PasteAction[];
}) {
  return (
    <div className="space-y-3">
      <TextAreaField
        hint={hint}
        id={id}
        label={label}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        value={value}
      />
      <div className="flex flex-wrap items-end gap-3">
        {header ? (
          <div className="w-full sm:w-64">
            <SelectField
              id={`${id}-header`}
              label={header.label}
              onChange={header.onChange}
              options={header.options}
              value={header.value}
            />
          </div>
        ) : null}
        {actions.map((action) => (
          <button
            className={BUTTON_SMALL}
            key={action.label}
            onClick={action.onClick}
            type="button"
          >
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
}
